module.exports = __webpack_public_path__ + "img/Ocio.0ea30e98.svg";